import React, { useState } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { 
    Button, Dialog, DialogTitle, DialogContent, DialogActions, 
    FormControl, FormLabel, TextField, CircularProgress
} from "@material-ui/core"; 
import { useForm, Controller } from "react-hook-form"; 
import { API } from "aws-amplify";
import { SkillGroup } from '../../../types/SkillTypes';

const useStyles = makeStyles((theme: Theme) => 
    createStyles({
        label: {
            marginBottom: 6
        }
    })
);

interface AddSkillDialogProps {
    openDialog: boolean
    handleSkillDialog: (open: boolean) => void
    group?: string
    skills: Array<SkillGroup>
}

interface AddSkillForm {
    skill: string
}

export default function AddSkillDialog({ openDialog, handleSkillDialog, group, skills }: AddSkillDialogProps) {

    const classes = useStyles()

    const { handleSubmit, control, errors, setError } = useForm<AddSkillForm>();
    const [loading, setLoading] = useState<boolean>(false) 

    function onSubmit(data: AddSkillForm) {
        if(data.skill.includes('#')) {
            setError("skill", {
                type: "required",
                message: "Invalid Character. Cannot contain # symbol."
              })
              return

        } else {
            setLoading(true)

            if(skills.length !== 0) {
                for(let i = 0; i < skills.length; i++) {
                    if(skills[i].Group === group) {
                        skills[i].Skills.push(data.skill)
                        break;
                    }
                }
            }
            
            const params = {
                body:{
                    data: skills,
                }
            };

            API.post("", "/skills/setSkills", params)
            .then((response: any) => {
                setLoading(false)
                handleSkillDialog(false)
            })
            .catch((error: any) => {
                console.log("ERROR: posting skills", error)
                setLoading(false)
            })
        }
    }

    return (
        <Dialog fullWidth maxWidth={'sm'} open={openDialog} onClose={() => handleSkillDialog(false)}>
            <DialogTitle>
                {group ?
                    <span>Add {group} Skill</span>
                :
                    <span>Add Skill</span>
                }
            </DialogTitle>
            <DialogContent>
                <FormControl
                    error={Boolean(errors.skill)} 
                    style={{width: "100%"}}>

                    <FormLabel className={classes.label}>Skill</FormLabel>

                    <Controller
                        as={
                            <TextField
                                placeholder="Enter Skill"
                                fullWidth
                                variant="filled"
                                error={errors.skill ? true : false}
                                helperText={errors.skill?.message}/>
                        }
                        name="skill"
                        control={control}
                        defaultValue=""
                        rules={{
                            required: "This is required"
                        }}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={() => handleSkillDialog(false)}>
                    Cancel
                </Button>
                {loading ? 
                    <Button variant="contained" color="primary">
                        <CircularProgress size={25} style={{color: "white"}}/>
                    </Button>
                :
                    <Button onClick={handleSubmit(onSubmit)} variant="contained" color="primary">
                        Add
                    </Button>
                }
            </DialogActions>
        </Dialog>
    )
}